import getTheme from "./getTheme";
export default function lineHeight(lineHeight, theme) {
    return getTheme(theme).lineHeight[lineHeight];
}
//# sourceMappingURL=lineHeight.js.map